import { IContactCooperator, IDataCooperator } from '~/pages/trucker-[id]/partner/-components/imports/form'
import { addQuote } from '~/pages/trucker-[id]/quote/-components/ignore/imports/form'

export interface IQuoteRequest {
  _id?: string
  code?: string
  customer: string
  commodity: string
  customerName: string
  contact: string
  businessOpportunityName: string
  contactData?: { [key: string]: any }
  businessOpportunity: string
  businessOpportunityData?: { [key: string]: any }
  workflow: string
  commodityName?: string
  workflowData: { [key: string]: any }
  tasks: Array<{ [key: string]: any }>
  request: string
  requestSpecial: string
  contactName: string
  mergeContainer: boolean
  headContainer: boolean
  productivity: number | null
  weightCommodity: number | null
  transportation: string | null
  vehicleCategory: string | null
  contCategory: number | null
  workflowName?: string | null
  positions?: Array<{ [key: string]: any }>
  contName?: string | null
  vehicleCategoryName?: string | null
  cooperatorDetail?: IDataCooperator
  contactDetail?: IContactCooperator
  typeCommodity?: string
  typeReefer?: string
  goodType?: string
  typeDangerous?: string
  typeFragileGoods?: string
  requestPrice?: boolean
  isHaveBeanCreated?: boolean
  status: number
  routingPositions?: { [key: string]: any }
  routingPositionsConnections?: { [key: string]: any }
  routingConnections?: string[] // trái tuyến
  connectingPositions?: string[] // vị trí tính trái tuyến
}

export interface IDataQuote {
  _id?: string
  code?: string
  customer: string
  commodity: string
  customerName: string
  contact: string
  businessOpportunityName: string
  contactData?: { [key: string]: any }
  businessOpportunity: string
  businessOpportunityData?: { [key: string]: any }
  workflow: string
  commodityName?: string
  workflowData: { [key: string]: any }
  tasks: Array<{ [key: string]: any }>
  request: string
  requestSpecial: string
  contactName: string
  mergeContainer: boolean
  headContainer: boolean
  productivity: number | null
  weightCommodity: number | null
  transportation: string | null
  vehicleCategory: string | null
  contCategory: number | null
  workflowName?: string | null
  positions?: Array<{ [key: string]: any }>
  contName?: string | null
  vehicleCategoryName?: string | null
  cooperatorDetail?: IDataCooperator
  contactDetail?: IContactCooperator
  typeCommodity?: string
  typeReefer?: string
  goodType?: string
  typeDangerous?: string
  typeFragileGoods?: string
  requestPrice?: boolean
  status: number
}

export interface ICostingSetting {
  priceInsurance: {
    value: number
    text: string
  }
  priceOline: {
    value: number
    text: string
  }
  repairCost: {
    value: number
    text: string
  }
  priceVehicleTires: {
    value: number
    text: string
  }
  priceStoll: {
    value: number
    text: string
  }
  priceTiresRemooc?: {
    value: number
    text: string
  }
  priceAssumptionRemooc?: {
    value: number
    text: string
  }
  priceAssumptionDriver: {
    value: number
    text: string
  }
  priceAssumptionHead: {
    value: number
    text: string
  }
  total?: number
}

interface IPriceCosting {
  text?: string
  _id?: string
  total?: number
  totalCosting?: number
  costingDetail: Array<{ [key: string]: any }>
}

export interface ISearchPriceDetail {
  _id?: string
  isMain?: boolean
  type: string
  createdAt: string
  positions: Array<{ [key: string]: any }>
  priceOline: {
    price?: number
    priceKm?: number
  }
  assumption: {
    travelTime: number // Thời gian đi lại
    totalTask: number // Tổng thời gian tác vụ
    workingDayByMonth: number // Số ngày làm việc
    averageTravelTimeByMonth: number // Số chuyến trung bình xe trên tháng
    vehicleType: string // Loại xe
    totalVehicle: number // Tổng số xe còn lại trong niên hạn
    averageGasOline: number // Giá dầu trung bình
    totalKm: number // Tổng km
    totalKmHaveGoods: number // Tổng km có hàng
  }
  costingSetting: ICostingSetting
  priceCosting: Array<IPriceCosting> | null
  pricingEstimate: {
    total: number
    priceFinancialCharges: number
    spendingLimit: number
    interestRate: number
    selling: number
    commission: number
    markup: number
    profit: number
    totalOfflineFee: number
  }
  policy?: {
    freeHourNumber: number
    moocKeepHourly: number
    moocKeepOvernight: number
    calculatedByHourNextDay?: string
    moocKeepLongTerm: number
    calculatedFromEvening: number
    towingContainerSunday: number
    towingContainerHoliday: number
    reeferPluginChargesGenerator: number
  }
  vendorId?: string
  priceVendorId?: string
  vendorName?: string
  priceVendorData?: {
    acceptPriceOfflineFee: Array<{ [key: string]: any }>
    contact: { [key: string]: any }
  }
  extendPrice?: boolean
}

export interface ISearchPrice {
  customer?: string
  customerName?: string
  address?: string
  prices?: Array<ISearchPriceDetail>
  priceOfflineFee?: Array<ISearchPriceDetail>
}
export interface IQuote {
  _id?: string
  customer?: string
  customerName?: string
  address?: string
  vehicleCategory?: string
  vehicleCategoryName?: string
  prices?: Array<ISearchPriceDetail>
  pricesNotRouteGGMap?: Array<ISearchPriceDetail>
  extendsPrice?: Array<ISearchPriceDetail>
  extendsPriceNotRouteGGMap?: Array<ISearchPriceDetail>
  priceOfflineFee?: Array<ISearchPriceDetail>
  priceOfflineFeeNotRouteGGMap?: Array<ISearchPriceDetail>
  quoteRequestData: IQuoteRequest | addQuote
  dataConfig: {
    duration: number
    commission: number
    corporateIncomeTax: number
    monthlyInterest: number
    priceGasOline: number
    incrementLevel: number
    markup: number
  }
  costingErrors: null | { [key: string]: any }
  priceSystemError: null | { [key: string]: any }
  quoteTempSaveId: string
  statusApprovalMarkup: number | null
  minMarkupConfirm: number | null
  markupAvailable: boolean
  customerService?: {
    id: string
    name: string
    phone: string
  }
  abstemious?: {
    id: string
    name: string
    phone: string
  }
  alerts?: {
    [key: string]: any
  }
  comfirmRouteGGMap?: boolean
}

export default {}
